import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { FormattedMessage } from 'ui/i18n';

import './ConfirmUnvalidatedDropshipModal.scss';

@inject('CartItemsState', 'AppState')
@observer
export default class ConfirmUnvalidatedDropshipModal extends Component {
	static propTypes = {
		CartItemsState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		show: PropTypes.bool.isRequired,
		onEdit: PropTypes.func.isRequired,
		onRequestConfirm: PropTypes.func.isRequired,
	};

	@action
	onEdit() {
		this.props.onEdit();
	}

	@action
	onConfirm() {
		this.props.onRequestConfirm();
	}

	render() {
		const { show } = this.props;

		return (
			<Modal
				className="ReactModal__Content ConfirmUnvalidatedDropship"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={this.onEdit.bind(this)}
				onRequestConfirm={this.onConfirm.bind(this)}
				contentLabel="ConfirmUnvalidatedDropship"
			>
				<h5 className="dropship-title">
					<FormattedMessage id="dropship.unvalidatedAddress" />
				</h5>

				<div className="modal-controls">
					<button
						className="btn btn-primary"
						onClick={this.onConfirm.bind(this)}
					>
						<FormattedMessage id="confirm.Button" />
					</button>

					<button
						className="btn btn-secondary"
						onClick={this.onEdit.bind(this)}
					>
						<FormattedMessage id="edit.Button" />
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ConfirmUnvalidatedDropship/index.js